
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";

const testimonials = [
  {
    quote: "planniFi has transformed how we approach media planning. The real-time analytics and forecasting capabilities have given us unprecedented insight into our campaigns.",
    author: "Sarah J.",
    role: "Marketing Director",
    company: ""
  },
  {
    quote: "The platform's intuitive interface and powerful features have made our budgeting process 40% more efficient. It's become an indispensable tool for our team.",
    author: "Michael C.",
    role: "Media Planning Manager",
    company: ""
  },
  {
    quote: "Since implementing planniFi, our forecast accuracy has improved dramatically. The ROI analysis tools have helped us optimize our media spend effectively.",
    author: "Emma R.",
    role: "Head of Digital",
    company: ""
  }
];

const Testimonials = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section className="pt-8 md:pt-16 pb-8 px-6 bg-surface">
      <div 
        ref={ref}
        className={`max-w-7xl mx-auto transition-all duration-1000 transform ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <h2 className="text-[2.25rem] leading-[1.1] md:text-6xl font-medium tracking-tight text-primary text-center mb-8 md:mb-16 font-charter">
          Trusted by industry leaders
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className="border-2 border-primary/20 p-8 rounded-xl bg-white shadow-sm"
              style={{
                transitionDelay: `${index * 200}ms`
              }}
            >
              <div className="space-y-4">
                <p className="text-primary/80 italic">"{testimonial.quote}"</p>
                <div className="pt-4 border-t border-primary/10">
                  <p className="font-medium text-primary">{testimonial.author}</p>
                  <p className="text-sm text-primary/70">{testimonial.role}</p>
                  <p className="text-sm text-primary/50">{testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
